import(/* webpackMode: "eager" */ "/home/runner/work/fulcrum-foundation/fulcrum-foundation/node_modules/next/dist/client/image-component.js");
